import { Box, Modal } from 'app/components/design-system-components'
import {
  ActivityFeedItem,
  ActivityItemProps,
} from 'app/shared_components/activity_feed/Activities'

interface ViewingHistoryModalProps {
  toggleModal: () => void
  activities: ActivityItemProps[]
  friendlyName?: string
}

function ViewingHistoryModal({
  toggleModal,
  activities,
  friendlyName = '',
}: ViewingHistoryModalProps) {
  const modalBody = (
    <Box>
      <Box mt={4} mb={6} lineHeight="1.4">
        The following events have occurred for the selected viewing for{' '}
        {friendlyName} (limit of 12 events).
      </Box>
      <>
        {activities?.length > 0 ? (
          activities?.map((activity, idx) => (
            <ActivityFeedItem
              activity={activity}
              lastItem={idx === activities.length - 1}
              key={idx}
              showLink={false}
              showAddress={false}
            />
          ))
        ) : (
          <Box>No viewing history</Box>
        )}
      </>
    </Box>
  )
  return (
    <Modal
      modalHeading="Viewing history"
      modalBody={modalBody}
      modalFooter={<div>Footer content</div>}
      showPrimaryButton={false}
      primaryLabel=""
      primaryAction={null}
      secondaryLabel="Close"
      secondaryAction={() => toggleModal()}
      toggleModal={() => toggleModal()}
    />
  )
}

export default ViewingHistoryModal
